import BottleFeeds from '../sections/bottleFeeds/bottleFeeds';

export default function BottleFeedsPage() {
  return (
    <div className="section-page">
      <BottleFeeds />
    </div>
  );
}
